import { gql } from '@apollo/client';

export const ALL_REASON_FOR_TERMINATIONS = gql`
  query AllReasonForTerminations {
    reasonForTerminations: getReasonForTerminations {
      id
      name
    }
  }
`;
